

























import { composeDateRange } from "@/helpers/dateHelpers";
import { LineItem } from "@/models/campaign";
import {
  CampaignReportData,
  CampaignReportItem,
} from "@/models/CampaignReport";
import { Component, Prop, Vue } from "vue-property-decorator";
import LineItemTable from "./LineItemTable.vue";
import ApexCharts from "vue-apexcharts";
import { get, padStart, round } from "lodash";
import BaseDivider from "@/components/BaseDivider.vue";
import { DefinitionBatch } from "@/models/definition";
import Site from "@/models/site";
import AdUnit from "@/models/adUnit";

@Component({
  components: { LineItemTable, ApexCharts, BaseDivider },
})
export default class LineItemReport extends Vue {
  @Prop() lineItem!: Required<LineItem>;
  @Prop() data!: CampaignReportData;
  @Prop() definitions!: DefinitionBatch[];
  @Prop() sites!: Site[];
  @Prop() adUnits!: AdUnit[];

  created(): void {
    console.log(this.lineItem);
    this.data.data.forEach((d) => {
      // console.log(d.lineItemId, this.lineItem.id);
    });
  }

  get dateRange(): string {
    return composeDateRange(this.lineItem.start, this.lineItem.end);
  }

  get subset(): CampaignReportItem[] {
    return this.data.data.filter((i) => i.lineItemId == this.lineItem.id);
  }

  get categories(): string[] {
    return this.subset.map(
      (i) => `${i.year}-${padStart(String(i.month), 2, "0")}`
    );
  }

  get options() {
    return {
      title: {
        text: this.$t("reports.campaign.click_print_summary"),
      },
      xaxis: {
        title: { text: this.$t("reports.campaign.year_month") },
        categories: this.categories,
      },
      yaxis: [
        {
          title: { text: this.$t("reports.campaign.print_amount") },
        },
        {
          opposite: true,
          title: { text: this.$t("reports.campaign.click_amount") },
        },
      ],
    };
  }

  get series() {
    return [
      {
        name: this.$t("reports.campaign.prints"),
        type: "column",
        data: this.subset.map((i) => i.prints),
      },
      {
        name: this.$t("reports.campaign.clicks"),
        type: "line",
        data: this.subset.map((i) => i.clicks),
      },
    ];
  }

  get ctr() {
    const options = {
      title: {
        text: this.$t("reports.campaign.ctr_summary"),
      },
      xaxis: {
        title: { text: this.$t("reports.campaign.year_month") },
        categories: this.categories,
      },
      yaxis: {
        title: { text: this.$t("reports.campaign.porcentual_value") },
      },
    };

    const series = [
      {
        name: "CTR",
        type: "line",
        data: this.subset.map((i) => round(i.ctr ? i.ctr * 100 : 0, 3)),
      },
    ];

    return { options, series };
  }

  getSite(id: string): string {
    const site = this.sites.find((e) => e.id === id);
    return site ? site.name : "";
  }

  getAdUnit(id: string): string {
    const adUnit = this.adUnits.find((e) => e.id === id);

    return adUnit ? adUnit?.name : "";
  }

  getDefinition(id: string): string {
    let definition;
    this.definitions.forEach((e) => {
      const value = e.values.find((d) => get(d, "id") === id);
      value ? (definition = value) : null;
    });
    return definition ? get(definition, "name") : "";
  }
}
